// AUTO-EXTRACTED from SourceSecurity.com via Claude Sonnet 4.6 + Playwright MCP
// Generated: 2026-05-16
// Specs parsed from public product spec sheets; no values invented.
// All entries marked verified: false — reviewer must spot-check before promotion.

import type { EquipmentCatalogEntry } from '../equipmentCatalogEntry';

export const SS_KEYPADS: EquipmentCatalogEntry[] = [
  {
    id: "ss-dsc-pc1404",
    manufacturer: "DSC",
    model: "PC1404",
    category: "keypad",
    tagline: "DSC introduces the PowerSeries PC1404 control panel and keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc1404-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-wt5500",
    manufacturer: "DSC",
    model: "WT5500",
    category: "keypad",
    tagline: "DSC WT5500 2-way wireless wire-free keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-wt5500-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-lcd4501",
    manufacturer: "DSC",
    model: "LCD4501",
    category: "keypad",
    tagline: "DSC LCD4501 MAXSYS programmable-message LCD keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-lcd4501-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-wt5500b",
    manufacturer: "DSC",
    model: "WT5500B",
    category: "keypad",
    tagline: "DSC WT5500B 2-way wireless wire-free keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-wt5500b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-rfk5508",
    manufacturer: "DSC",
    model: "RFK5508",
    category: "keypad",
    tagline: "DSC RFK5508 PowerSeries 8-zone LED keypad with built-In wireless receiver",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-rfk5508-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-pc1404rkz",
    manufacturer: "DSC",
    model: "PC1404RKZ",
    category: "keypad",
    tagline: "DSC PC1404RKZ PowerSeries 8-Zone LED keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc1404rkz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-rfk5564",
    manufacturer: "DSC",
    model: "RFK5564",
    category: "keypad",
    tagline: "DSC RFK5564 - powerSeries 64-Zone LCD full-message keypad with built-In wireless receiver, 64 zones",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-rfk5564-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-pk5516",
    manufacturer: "DSC",
    model: "- PK5516",
    category: "keypad",
    tagline: "DSC PK5516 16-ZONE LCD Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pk5516-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-rfk5500",
    manufacturer: "DSC",
    model: "RFK5500",
    category: "keypad",
    tagline: "DSC RFK5500 PowerSeries 64-Zone LCD full-message keypad with built-In wireless receiver, 32 zones",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-rfk5500-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-pk5500",
    manufacturer: "DSC",
    model: "- PK5500",
    category: "keypad",
    tagline: "DSC PK5500 64-ZONE LCD full message keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pk5500-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-pk5508",
    manufacturer: "DSC",
    model: "- PK5508",
    category: "keypad",
    tagline: "DSC PK5508 8-ZONE LCD Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pk5508-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-pk5501",
    manufacturer: "DSC",
    model: "- PK5501",
    category: "keypad",
    tagline: "DSC PK5501 64-ZONE LCD full message keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pk5501-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-rfk5501",
    manufacturer: "DSC",
    model: "RFK5501",
    category: "keypad",
    tagline: "DSC RFK5501 PowerSeries 64-Zone LCD full-message keypad with built-In wireless receiver, 32 zones",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-rfk5501-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-led5511z",
    manufacturer: "DSC",
    model: "- LED5511Z",
    category: "keypad",
    tagline: "DSC LED5511Z 8-ZONE LED PowerSeries Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-led5511z-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dsc-rfk5516",
    manufacturer: "DSC",
    model: "RFK5516",
    category: "keypad",
    tagline: "DSC RFK5516 PowerSeries 16-zone LED keypad with built-In wireless receiver",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-rfk5516-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dsc-ptk5507",
    manufacturer: "DSC",
    model: "- PTK5507",
    category: "keypad",
    tagline: "DSC PTK5507 introduces the TouchScreen Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-ptk5507-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"touchscreen","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-visonic-hs2lcdwfpv8e2vis",
    manufacturer: "Visonic",
    model: "HS2LCDWFPV8E2VIS",
    category: "keypad",
    tagline: "Visonic HS2LCDWFPV8E2VIS 2-way wireless keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2lcdwfpv8e2vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-hs2lcdwfpv8e1vis",
    manufacturer: "Visonic",
    model: "HS2LCDWFPV8E1VIS",
    category: "keypad",
    tagline: "Visonic HS2LCDWFPV8E1VIS 2-way wireless keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2lcdwfpv8e1vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-hs2lcdpe1vis",
    manufacturer: "Visonic",
    model: "HS2LCDPE1VIS",
    category: "keypad",
    tagline: "Visonic HS2LCDPE1VIS hardwired LCD keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2lcdpe1vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-hs2lcdrfp8e2vis",
    manufacturer: "Visonic",
    model: "HS2LCDRFP8E2VIS",
    category: "keypad",
    tagline: "Visonic HS2LCDRFP8E2VIS LCD keypad with built-in PowerG transceiver",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2lcdrfp8e2vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-hs2lcdrfp8e1vis",
    manufacturer: "Visonic",
    model: "HS2LCDRFP8E1VIS",
    category: "keypad",
    tagline: "Visonic HS2LCDRFP8E1VIS LCD keypad with built-in PowerG transceiver",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2lcdrfp8e1vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-kp-160-pg2",
    manufacturer: "Visonic",
    model: "KP-160 PG2",
    category: "keypad",
    tagline: "Visonic introduces the touch-screen keypad KP-160 PG2",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-kp-160-pg2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"touchscreen","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-kp-250-pg2",
    manufacturer: "Visonic",
    model: "KP-250 PG2",
    category: "keypad",
    tagline: "Visonic KP-250 PG2 wireless two-way keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-kp-250-pg2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-visonic-hs2lcdpe2vis",
    manufacturer: "Visonic",
    model: "HS2LCDPE2VIS",
    category: "keypad",
    tagline: "Visonic HS2LCDPE2VIS hardwired LCD keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2lcdpe2vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-risco-group-lightsys-lcd-keypad",
    manufacturer: "RISCO Group",
    model: "LightSYS LCD Keypad",
    category: "keypad",
    tagline: "RISCO Group LightSYS LCD Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-lightsys-lcd-keypad-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-risco-group-rw132kp",
    manufacturer: "RISCO Group",
    model: "RW132KP",
    category: "keypad",
    tagline: "RISCO Group RW132KP - Agility™ 2-way wireless LCD keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-rw132kp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-risco-group-2-way-wireless-slim-keypad",
    manufacturer: "RISCO Group",
    model: "2-Way Wireless Slim Keypad",
    category: "keypad",
    tagline: "RISCO Group 2-Way Wireless Slim Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-2-way-wireless-slim-keypad-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-texecom-veritas-r8-plus",
    manufacturer: "Texecom",
    model: "Veritas R8 Plus",
    category: "keypad",
    tagline: "Texecom Veritas R8 Plus control panel with remote keypad along with 4 programmable part set suites",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-veritas-r8-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dahua-technology-ark50c-r",
    manufacturer: "Dahua Technology",
    model: "ARK50C-R",
    category: "keypad",
    tagline: "Dahua Technology ARK50C-R alarm keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ark50c-r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dahua-technology-ark50c",
    manufacturer: "Dahua Technology",
    model: "ARK50C",
    category: "keypad",
    tagline: "Dahua Technology ARK50C alarm keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ark50c-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-dahua-technology-ark30t-w2",
    manufacturer: "Dahua Technology",
    model: "ARK30T-W2",
    category: "keypad",
    tagline: "Dahua Technology ARK30T-W2 wireless keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ark30t-w2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-dahua-technology-ark30t-w2-868",
    manufacturer: "Dahua Technology",
    model: "ARK30T-W2(868)",
    category: "keypad",
    tagline: "Dahua Technology ARK30T-W2(868) wireless keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ark30t-w2-868-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-networx-nx-148e",
    manufacturer: "NetworX",
    model: "NX-148E",
    category: "keypad",
    tagline: "NetworX NX-148E LCD keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-148e-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-pyronix-pcx-contemporary-keypad",
    manufacturer: "Pyronix",
    model: "PCX Contemporary Keypad",
    category: "keypad",
    tagline: "Pyronix PCX Contemporary Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-pcx-contemporary-keypad-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-pyronix-ledrkp-white-we-wireless-arming-keypad",
    manufacturer: "Pyronix",
    model: "LEDRKP/WHITE-WE Wireless Arming Keypad",
    category: "keypad",
    tagline: "Pyronix LEDRKP/WHITE-WE Wireless Arming Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-ledrkp-white-we-wireless-arming-keypad-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-pyronix-pcx-keypad",
    manufacturer: "Pyronix",
    model: "PCX Keypad",
    category: "keypad",
    tagline: "Pyronix PCX Keypad to set or unset your security system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-pcx-keypad-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-verex-monitor-xl-lcd-keypad-plus",
    manufacturer: "Verex",
    model: "Monitor XL LCD Keypad Plus",
    category: "keypad",
    tagline: "Verex Monitor XL LCD Keypad Plus",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verex-monitor-xl-lcd-keypad-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-verkada-bk11-hw",
    manufacturer: "Verkada",
    model: "BK11-HW",
    category: "keypad",
    tagline: "Verkada BK11-HW Alarm Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bk11-hw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-verkada-bk21-hw",
    manufacturer: "Verkada",
    model: "BK21-HW",
    category: "keypad",
    tagline: "Verkada BK21-HW Alarm Keypad + Wireless Hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bk21-hw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kp-23b",
    manufacturer: "Climax Technology",
    model: "KP-23B",
    category: "keypad",
    tagline: "Climax Technology KP-23B wireless remote keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kp-23b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kp-23s",
    manufacturer: "Climax Technology",
    model: "KP-23S",
    category: "keypad",
    tagline: "Climax Technology KP-23S remote wireless keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kp-23s-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kp-23zb",
    manufacturer: "Climax Technology",
    model: "KP-23ZB",
    category: "keypad",
    tagline: "Climax Technology KP-23ZB wireless ZigBee keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kp-23zb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"ZigBee","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kpt-29zb",
    manufacturer: "Climax Technology",
    model: "KPT-29ZB",
    category: "keypad",
    tagline: "Climax Technology KPT-29ZB wireless ZigBee information keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kpt-29zb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"ZigBee","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kp-29zb",
    manufacturer: "Climax Technology",
    model: "KP-29ZB",
    category: "keypad",
    tagline: "Climax Technology KP-29ZB wireless ZigBee remote keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kp-29zb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"ZigBee","compatibility":[]},
  },
  {
    id: "ss-climax-technology-ml-1b",
    manufacturer: "Climax Technology",
    model: "ML-1B",
    category: "keypad",
    tagline: "Climax Technology ML-1B IP Based, Rubber Keypad Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-1b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-climax-technology-ml-8b",
    manufacturer: "Climax Technology",
    model: "ML-8B",
    category: "keypad",
    tagline: "Climax Technology ML-8B 3G + GPRS + IP, Rubber Keypad Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-8b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-climax-technology-ml-3b",
    manufacturer: "Climax Technology",
    model: "ML-3B",
    category: "keypad",
    tagline: "Climax Technology ML-3B 3G + GPRS, Rubber Keypad Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-3b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kp-39-f1",
    manufacturer: "Climax Technology",
    model: "KP-39-F1",
    category: "keypad",
    tagline: "Climax Technology KP-39-F1 wireless remote keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kp-39-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kpt-39-f1",
    manufacturer: "Climax Technology",
    model: "KPT-39-F1",
    category: "keypad",
    tagline: "Climax Technology KPT-39-F1 wireless remote keypad with RFID key fob",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kpt-39-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kpt-39n-f1",
    manufacturer: "Climax Technology",
    model: "KPT-39N-F1",
    category: "keypad",
    tagline: "Climax Technology KPT-39N-F1 wireless remote keypad with NFC tag",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kpt-39n-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"led","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kpt-35-combo",
    manufacturer: "Climax Technology",
    model: "KPT-35-Combo",
    category: "keypad",
    tagline: "Climax Technology KPT-35-Combo wired and wireless keypad with RFID key fob",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kpt-35-combo-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kp-35-combo",
    manufacturer: "Climax Technology",
    model: "KP-35-Combo",
    category: "keypad",
    tagline: "Climax Technology KP-35-Combo wired and wireless keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kp-35-combo-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kpt-35n-combo",
    manufacturer: "Climax Technology",
    model: "KPT-35N-Combo",
    category: "keypad",
    tagline: "Climax Technology KPT-35N-Combo wired and wireless keypad with NFC tags",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kpt-35n-combo-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wireless","compatibility":[]},
  },
  {
    id: "ss-climax-technology-kpt-35-n-bus-series",
    manufacturer: "Climax Technology",
    model: "KPT-35(N)-BUS Series",
    category: "keypad",
    tagline: "Climax Technology KPT-35(N)-BUS Series Wired Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-kpt-35-n-bus-series-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"lcd-text","connection":"wired","compatibility":[]},
  },
  {
    id: "ss-climax-technology-tsp-bus",
    manufacturer: "Climax Technology",
    model: "TSP-BUS",
    category: "keypad",
    tagline: "Climax Technology TSP-BUS Touchscreen Keypad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-tsp-bus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"display":"touchscreen","connection":"wired","compatibility":[]},
  },
];
